module.exports = require("electron");


//////////////////
// WEBPACK FOOTER
// external "electron"
// module id = 1539
// module chunks = 1